import ContractForSupply from './contract-for-supply-container';

export default ContractForSupply;